import { ProtectedPage } from '~/src/components/templates/ProtectedPage/ProtectedPage'
import { Box, Button, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Add from '@mui/icons-material/Add'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

import { TableContainerUserID } from '~/src/components/pages/MemberSupportHistory/components/TableContainerUserID'
import { useTranslation } from 'react-i18next'
import { memberRepository } from '~/src/repositories'
import { THistories } from '~/src/repositories/MemberRepository/model/SupportHistory'
export const MemberSupportHistory: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const [supportHistories, setSupportHistories] = useState<THistories | any>()
  const [paging, setPaging] =
    useState<{ currentPage: number; limitValue: number; totalCount: number; totalPages: number }>()

  useEffect(() => {
    fetchSupportHistories()
  }, [])

  const fetchSupportHistories = async () => {
    try {
      const data = await memberRepository.getSupportHistory()
      setSupportHistories(data?.histories)
      setPaging(data?.pagination)
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <ProtectedPage pageTitle={t('support_history_user_id.correspondence_history_list')}>
      <Stack direction="row" spacing={2} justifyContent={'flex-end'} mb={'28px'}>
        <Box sx={{ minWidth: 220, background: '#FFFFFF', marginLeft: '8px' }}>
          <FormControl fullWidth size="small">
            <InputLabel
              id="container-order-list-select-label"
              sx={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: 16,
                letterSpacing: 0.15,
                color: 'rgba(0, 0, 0, 0.6)',
              }}
            >
              {t('support_history_user_id.member')}
            </InputLabel>
            <Select
              labelId="container-order-list-select-label"
              id="container-order-list-select-label"
              label="会員"
              sx={{
                '& .MuiOutlinedInput-input': {
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: 16,
                  letterSpacing: 0.15,
                },
                height: 40,
              }}
            >
              <MenuItem
                value={10}
                sx={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: 16,
                  letterSpacing: 0.15,
                }}
              >
                会員
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Button variant="contained" sx={{ marginLeft: '8px' }}>
          <Add />
          <Typography
            sx={{
              marginLeft: '12px',
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: 16,
              letterSpacing: 0.15,
              lineHeight: '24px',
            }}
          >
            {t('support_history_user_id.add_new')}
          </Typography>
        </Button>
      </Stack>
      <TableContainerUserID users={supportHistories} paging={paging} />
    </ProtectedPage>
  )
}
